import React from 'react';
import { string } from 'prop-types';
import { Link } from 'react-router-dom';

import FooterContainer from '../../components/FooterContainer/FooterContainer';
import Routes from '../../components/Routes';
import Button from '../../elements/Button/Button';
import strings from '../../lang/lang';

import { ReactComponent as Icon404 } from '../../styles/icon/icon-404.svg';
import { ReactComponent as Home } from '../../styles/icon/home.svg';
import not_found from './NotFound.module.scss';

NotFound.propTypes = {
  message: string
}

function NotFound(props) {
  const { message } = props;
  const text = message ? message : strings.notFound.text.notPage;
  return (
    <>
      <div className={not_found.not_found}>
        <div className={not_found.not_found__container}>
          <div className={not_found.not_found__box}>
            <div className={not_found.not_found__title}>
              <h1>{strings.notFound.text.title}</h1>
            </div>
            <div className={not_found.not_found__not_app}>
              <Icon404 />
              <h4>{text}</h4>
              <div className={not_found.not_found__text}>
                <p>{strings.notFound.text.visit}</p>
              </div>
              <div className={not_found.not_found__btn_create_center}>
              <Link to={Routes.routes.ROOT.path}>
                <Button
                    name={strings.notFound.button.homepage}
                    variant="primary"
                    secondaryClassName="create"
                  >
                    <Home />
                  </Button>
              </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FooterContainer />
    </>
  );
};

export default NotFound;
